// Classificatore dei contatti in rubrica.
// I tipi sono gestibili dall'utente (tabella tipi_contatto lato backend): questi
// valori restano solo come fallback finché l'elenco non è stato caricato.

export interface TipoContattoOption {
  value: string;
  label: string;
  colore?: string;
}

export const TIPI_CONTATTO_DEFAULT: TipoContattoOption[] = [
  { value: 'PRIVATO', label: 'Privato', colore: '#2E7D32' },
  { value: 'AZIENDA', label: 'Azienda', colore: '#1565C0' },
  { value: 'CLIENTE', label: 'Cliente', colore: '#3949AB' },
  { value: 'CLIENTE_TOP', label: 'Cliente Top', colore: '#F57F17' },
  { value: 'COLLABORATORE', label: 'Collaboratore', colore: '#00695C' },
  { value: 'AGENTE', label: 'Agente', colore: '#6A1B9A' },
];

// Palette usata per i tipi creati dall'utente che non hanno un colore esplicito
const PALETTE_CUSTOM = ['#3949AB', '#00695C', '#6A1B9A', '#C62828', '#EF6C00', '#00838F', '#4527A0', '#558B2F'];

/** Colore stabile per un codice tipo: sempre lo stesso a parità di codice. */
export const coloreTipoContatto = (value?: string, colore?: string): string => {
  if (colore) return colore;
  const def = TIPI_CONTATTO_DEFAULT.find((t) => t.value === value);
  if (def?.colore) return def.colore;
  if (!value) return PALETTE_CUSTOM[0];
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = (hash * 31 + value.charCodeAt(i)) % 100000;
  }
  return PALETTE_CUSTOM[hash % PALETTE_CUSTOM.length];
};

/** Etichetta leggibile per un codice tipo, dato l'elenco caricato. */
export const tipoContattoLabelFrom = (tipi: TipoContattoOption[], value?: string): string => {
  const found = tipi.find((t) => t.value === value);
  if (found) return found.label;
  if (!value) return 'Privato';
  // Tipo non più presente in elenco: mostriamo il codice in forma leggibile
  return value
    .split('_')
    .map((p) => (p ? p.charAt(0) + p.slice(1).toLowerCase() : p))
    .join(' ');
};
